<template>
    <div>
        <div
            class="px-3 py-1.5 font-body-sm-semibold rounded-2"
            :style="`background-color:${selectedItem?.bgColor}; color:${selectedItem?.textColor};`"
        >
            {{ selectedItem?.text }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        statusCode: { type: String, default: 'ACTIVE' },
    },
    data() {
        return {
            employeeStatus: [
                { bgColor: '#34D3991F', textColor : "#34D399", text: 'Active',     code: 'ACTIVE',  },
                { bgColor: '#D0E1F2', textColor : "#3F85CA", text: 'Inactive',   code: 'ON_LEAVE',  },
                { bgColor: '#D8D8D8', textColor : "#666565", text: 'Resigned',   code: 'RESIGNED',  },
                { bgColor: '#FFC2001A', textColor : "#FFC200", text: 'Extension Required', code: 'EXTENSION_REQUIRED',  },
                { bgColor: '#A22FE81A', textColor : "#A22FE8", text: 'Extension Past Due', code: 'EXTENSION_PAST_DUE',  },
                { bgColor: '#F420531A', textColor : "#F42053", text: 'Contract Info Required', code: 'CONTRACT_INFO_REQUIRED',  },
            ],
            selectedItem: null,
        };
    },
    watch: {
        statusCode(newVal) {
            if (!newVal) {
                return;
            }
            const self = this;
            self.initStatus();
        },
    },
    mounted() {
        const self = this;
        self.initStatus();
    },
    methods : {
        initStatus(){
            const self = this;
            self.selectedItem = self.employeeStatus.find((status) => status.code === self.statusCode);
        }
    }
}
</script>